import { isNonEmptyArray } from "../../../utils";
import { FORM_TYPES } from "../form-enum";

export const generateLayout = (items, editMode) => {
	const layout = [];
	items
		.filter((block) => !block?.hidden)
		.forEach((item) => {
			const { x, y, w, h } = item;
			const width = w || 1;
			const height = h || 1;
			layout.push({
				...item,
				i: item.id,
				static: !editMode,
				x,
				y,
				w: width,
				h: height,
			});
		});
	return layout;
};

export function isValidAndNonOverlapping(shapes, maxWidth) {
	if (!isNonEmptyArray(shapes) || Number.isNaN(maxWidth) || maxWidth < 0 || maxWidth > 10) {
		return false;
	}
	for (let i = 0; i < shapes.length; i++) {
		const shape = shapes[i];
		const { x, y, w, h } = shape;
		if (
			x === undefined ||
			y === undefined ||
			w === undefined ||
			h === undefined ||
			x < 0 ||
			y < 0 ||
			w < 1 ||
			h < 1 ||
			x + w > maxWidth
		) {
			return false;
		}
		for (let j = i + 1; j < shapes.length; j++) {
			const otherShape = shapes[j];
			if (
				x < otherShape.x + otherShape.w &&
				x + w > otherShape.x &&
				y < otherShape.y + otherShape.h &&
				y + h > otherShape.y
			) {
				return false;
			}
		}
	}
	return true;
}

const validateDimensions = (block) => {
	const minHText = 1;
	const minHDate = 1;
	const minHList = 1;
	if (FORM_TYPES.TEXT === block.type) {
		const tempH = (!Number.isNaN(block?.h) && block.h >= minHText && block.h) || minHText;
		return { minH: minHText, h: tempH };
	}
	if (FORM_TYPES.DATE === block.type || FORM_TYPES.DATETIME === block.type) {
		const tempH = (!Number.isNaN(block?.h) && block.h >= minHDate && block.h) || minHDate;
		return { minH: minHDate, h: tempH };
	}
	if (FORM_TYPES.TREE === block.type) {
		const tempH = (!Number.isNaN(block?.h) && block.h >= minHList && block.h) || minHList;
		return { minH: minHList, h: tempH };
	}
	return { minH: 1, h: 1 };
};

export const regenerateCorrectLayout = (items, editMode) => {
	const layout = [];
	let currentY = 0;
	const positions = Array(4).fill(0);
	items
		.filter((block) => !block?.hidden)
		.forEach((item) => {
			const w = 1;
			const { minH, h } = validateDimensions(item);
			const minW = 1;
			let x = positions.findIndex((pos) => pos <= currentY);
			if (x === -1) {
				x = 0;
				currentY += h;
			}
			layout.push({ ...item, i: item.id, static: !editMode, x, y: positions[x], w, h, minW, minH });
			positions[x] += h;
		});

	return layout;
};
